/* External Imports */
import React from 'react';

/* Built In Imports */
import { Box, Image } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/**
 * @param {Object} sectionContent
 * @param {String} lang
 * @param {String} region
 * @returns
 */

const RemarketCovere = ({ region, lang, sectionContent }) => {
  const programHeading = sectionContent?.find(
    e => e.fieldId === 'covered-heading'
  );
  const programSubHeading = sectionContent?.find(
    e => e.fieldId === 'covered-text'
  );
  const ratedImage = sectionContent?.find(e => e.fieldId === 'rated-img');
  const trustedByImage = sectionContent?.find(
    e => e.fieldId === 'trusted-by-img'
  );

  return (
    <Box bg="#fff">
      <Box
        p={{ base: '3.875rem 1.25rem', md: '7.125rem 1.25rem' }}
        borderRadius="lg"
        color={'#525252'}
        maxWidth="1920px"
        mx="auto"
      >
        {/* Centered Heading */}
        {programHeading && (
          <StructuredTextParser
            str={render(programHeading?.body)}
            fontSize={{ base: '1.625rem', md: '3.125rem' }}
            lineHeight={{ base: '2.11rem', md: '4.25rem' }}
            fontFamily="FedraSansStd-medium"
            textAlign="center"
            maxW={'100% !important'}
            mx="auto"
            className="covered_heading"
            px='45px'
          />
        )}

        {/* Centerd SubHeading */}
        {programSubHeading && (
          <StructuredTextParser
            str={render(programSubHeading?.body)}
            fontSize={{ base: '1.125rem', md: '1.5rem' }}
            lineHeight={{ base: '1.46rem', md: '2.1rem' }}
            fontFamily="FedraSansStd-medium"
            textAlign="center"
            maxW={'100% !important'}
            mb={{ base: '3px', md: '47px' }}
            mx="auto"
            className="covered_SubHeading"
          />
        )}

        {/* Two-Column Layout for Items */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexDirection="column"
          gap="1rem"
          maxWidth="1140px"
          width="100%"
          mx="auto"
          mt={{ base: '2.5rem', md: '3.5rem' }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexDirection={{ base: 'column', md: 'row' }}
            width="100%"
            gap="1rem"
            mx="auto"
            // mt='2.5rem'
          >
            {/* First left box */}
            <Box
              align="baseline"
              gap="1.25rem"
              backgroundColor="#F7F7F7"
              width="100%"
              padding="5px"
            >
              <Box
                width="100%"
                height="100%"
                textAlign="center"
                py={{ base: '3rem', md: '4.5rem' }}
                px={{ base: '1rem', md: '3rem' }}
              >
                {ratedImage && (
                  <Image
                    src={sectionContent[2]?.image?.url}
                    alt={sectionContent[2]?.image?.alt}
                  />
                )}
                <StructuredTextParser
                  str={render(sectionContent[3]?.body)}
                  color="#A81D28"
                  fontSize={{ base: '1rem', md: '1.5rem' }}
                  lineHeight={{ base: '1.3rem', md: '1.95rem' }}
                  fontFamily="FedraSansStd-book"
                  className="rated_Text"
                  textAlign="center"
                  whiteSpace="pre-line"
                />
              </Box>
            </Box>

            {/* Second right box */}
            <Box
              align="baseline"
              gap="1.25rem"
              backgroundColor="#F7F7F7"
              width="100%"
            >
              <Box
                width="100%"
                height="100%"
                textAlign="center"
                py={{ base: '3rem', md: '4.5rem' }}
                px={{ base: '1rem', md: '3rem' }}
              >
                {trustedByImage && (
                  <Image
                    src={sectionContent[4]?.image?.url}
                    alt={sectionContent[4]?.image?.alt}
                  />
                )}
                <StructuredTextParser
                  str={render(sectionContent[5]?.body)}
                  color="#A81D28"
                  fontSize={{ base: '1rem', md: '1.5rem' }}
                  lineHeight={{ base: '1.3rem', md: '1.95rem' }}
                  fontFamily="FedraSansStd-book"
                  className="rated_Text"
                  textAlign="center"
                  whiteSpace="pre-line"
                />
              </Box>
            </Box>
          </Box>
          <Box
            align="baseline"
            gap="1.25rem"
            backgroundColor="#F7F7F7"
            width="100%"
            mx="auto"
          >
            <Box
              width="100%"
              height="100%"
              textAlign="center"
              py={{ base: '3rem', md: '4.5rem' }}
              px={{ base: '3rem', md: '4rem' }}
            >
              {trustedByImage && (
                <Image
                  src={sectionContent[6]?.image?.url}
                  alt={sectionContent[6]?.image?.alt}
                  mb={{ base: '1.5rem', md: '0.7rem' }}
                  mr={{ md: '1.35rem' }}
                />
              )}
              {trustedByImage && (
                <Image
                  src={sectionContent[7]?.image?.url}
                  alt={sectionContent[7]?.image?.alt}
                />
              )}
              <StructuredTextParser
                str={render(sectionContent[8]?.body)}
                color="#A81D28"
                fontSize={{ base: '1rem', md: '1.5rem' }}
                lineHeight={{ base: '1.3rem', md: '1.95rem' }}
                fontFamily="FedraSansStd-book"
                className="rated_Text"
                textAlign="center"
                whiteSpace="pre-line"
                mt={'25px'}
              />
            </Box>
          </Box>
        </Box>
        <style>
          {`
            .remark_que_program ul {
              list-style: none;
              list-style-image: url('https://www.datocms-assets.com/46272/1733399189-polygon_blue-icon.png');
            }
            .remark_que_program ul li {
              padding: 16px 0px 16px 8px;
            }
            .covered_heading mark {
              background: none;
              color: #12166f;
            }
            .covered_heading h2 {
              color: #f37021;
            }
            .covered_SubHeading p {
              font-family: 'FedraSansStd-book'
            }
            .covered_SubHeading mark {
              background: none;
              color: #525252;
              font-weight:500
              
            }
            .covered_SubHeading  {
              color: #12166f;
              font-weight:600
            }
            .rated_Text {
              color: #11146d;
            }
          `}
        </style>
      </Box>
    </Box>
  );
};

export default RemarketCovere;
